const BottomTextOnly = () => {
    return (
        <>
            <div className="mt-5 bottomText absolute text-center left-0 right-0 bottom-1">제40대선거관리위원회</div>
        </>
    )
}

export default BottomTextOnly;